/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import PrimaryBuildingInfoSection from './PrimaryBuildingInfoSection.jsx';

export default PrimaryBuildingInfoSection;
